declare global {
  interface Window {
    __WEARLAY_CONFIG__?: { API_BASE_URL?: string };
  }
}

// In a container the API URL comes from /runtime-config.js, which the nginx image renders at
// start from the API_BASE_URL environment variable (see nginx/40-runtime-config.sh), so one
// image serves every environment. Local development and builds that bake REACT_APP_API_BASE_URL
// in (the docker-host deployments) fall back to it.
export const env = {
  development: {
    API_URL: window.__WEARLAY_CONFIG__?.API_BASE_URL || process.env.REACT_APP_API_BASE_URL,
  },
};
